module.exports = __webpack_public_path__ + "static/colors-6dc31b8fd3c9c8654fd8de7b4fa11a44.gif";